var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.00728525C15.3036 0.496661 14.5324 0.870955 13.7164 1.11575C13.2784 0.614053 12.6962 0.25846 12.0488 0.0970684C11.4013 -0.064323 10.7196 -0.023726 10.0961 0.213369C9.47248 0.450463 8.93705 0.872616 8.56217 1.42273C8.18729 1.97285 7.99105 2.62438 8 3.28922V4.01371C6.72192 4.04672 5.45547 3.76435 4.31346 3.19174C3.17145 2.61913 2.18932 1.77405 1.45455 0.731774C1.45455 0.731774 -1.45455 7.25217 5.09091 10.1501C3.59311 11.1629 1.80884 11.6708 0 11.5991C6.54545 15.2216 14.5455 11.5991 14.5455 3.26749C14.5448 3.06568 14.5253 2.86438 14.4873 2.66616C15.2295 1.93696 15.7533 1.01629 16 0.00728525Z",
    fill: "#393184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.74684fee3870c1720526ffaaf9b3196e.svg";
export { ForwardRef as ReactComponent };